import { idNameItem, iif, JkEnvironment, jkRestReturn } from "jk-service";
import { AgCheckBoxEditor, AgTextAreaEditor } from "jk-service";
import { jkLib } from "jk-service";
import { Mtrwl } from "../entity/Mtrwl-angular";
import { MtrwlData, MtrwlServicePkg } from "./mtrwlPkg.service";
import { Injectable, signal } from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class MtrwlService extends MtrwlServicePkg {
  MtrWd015List: idNameItem[] = [];
  noteOrder = signal('1');
  noteOrderList = signal<idNameItem[]>([
    { id: '1', name: '1.星號置頂' },
    { id: '2', name: '2.最新修改' },
    { id: '3', name: '3.日期' },
  ]);
  constructor() {
    super();
    this.orm.doOpenWin_get('S', 'JCKMG', 'S01', ['MTRWD']).subscribe((data: any) => {
      if (data.result) this.MtrWd015List = data.obj;
    });
  }

  override async newRecord(newItem: Mtrwl): Promise<Mtrwl> {
    await super.newRecord(newItem);
    if (this.programId === 'stock') {

      if (newItem.WL001.length <= 10)
        newItem.WL010 = newItem.WL001; // 股票代號
    }
    newItem.WL002 = this.FindMaxSeq(); // ###
    newItem.WL003 = 99;//Number(newItem.WL002);
    newItem.WL005 = jkLib.nowDate();
    newItem.WL006 = new Date();
    newItem.WL012 = 'M';
    return newItem;
  }
  async toggleStar(item: any): Promise<void> {
    if (item.WL008 === 'Y') item.WL008 = 'N';
    else item.WL008 = 'Y';
  }
  async toggleStarUpdate(item: any): Promise<void> {
    if (item.WL008 === 'Y') item.WL008 = 'N';
    else item.WL008 = 'Y';
    let key = this.getKeyValues(item);

    await this.updateData(key, item);
    alert('已更新*');
  }
  async toggleTag(item: Mtrwl, isUpdate: boolean): Promise<void> {
    if (item.WL008 === 'Y') item.WL008 = 'N';
    else item.WL008 = 'Y';
    if (isUpdate) {
      await this.toggleTagUpdate(item);
    }
  }
  async toggleTagUpdate(item: any): Promise<void> {
    let key = this.getKeyValues(item);

    await this.updateData(key, item);
    alert('已更新*');
  }
  quillEditorReady(event: any) {
    if (event.text.trim() !== '') {
      this.item.WL013 = event.html;
      this.item.WL004 = event.text;
    }
  }
  textChange($event: string) {
    this.item.WL004 = $event;
  }
  htmlChange($event: string) {
    this.item.WL013 = $event;
  }
  override init() {
    super.init();
    this.columnDefs = [
      { field: "WL008", headerName: "星號", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WL005", headerName: "日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: (p: any) => { return jkLib.dateField2Display(p.value) }, },
      { field: "WL011", headerName: "tag", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WL003", headerName: "排序碼", headerTooltip: "", width: 102, cellDataType: "number", },
      {
        field: "WL007", headerName: "主旨", headerTooltip: "", width: 250, cellDataType: "text",
        cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,
      },
      {
        field: "WL004", headerName: "內文", headerTooltip: "", width: 400, maxWidth: 1000, cellDataType: "text",
        cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,
      },
      { field: "WL010", headerName: "股票代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "WL009", headerName: "來源單號", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "WL002", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", editable: true, },
      { field: "CREATE_DATE", headerName: "建檔日期", headerTooltip: "", width: 110, cellDataType: "text", editable: false },
      { field: "WL012", headerName: "格式", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "WL013", headerName: "html內文", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "WL014", headerName: "大分類", headerTooltip: "", width: 80, cellDataType: "text" },
      { field: "WL001", headerName: "單號", headerTooltip: "", width: 230, cellDataType: "text", hide: true },
      { field: "WL006", headerName: "Date", headerTooltip: "", width: 80, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, }, // ***
    ];
  }

  override async doBeforePost(item: Mtrwl, ret: jkRestReturn): Promise<boolean> {
    let bool = await super.doBeforePost(item, ret);
    if (bool) {
      item.WL006 = new Date();
    }
    return bool;
  }
  override async doMyOk(): Promise<boolean> {
    return super.doMyOk();
  }
  async getNotesList(query = '', starred = false): Promise<Mtrwl[]> {
    const params = new URLSearchParams();
    const starredFilter = starred ? ` AND WL008 = 'Y'` : '';
    const queryFilter = query.trim() !== '' ? ` AND ((WL007 LIKE '%${query.trim()}%')  OR (WL013 LIKE '%${query.trim()}%')) ` : '';
    this.sqlWhere = ` AND WL001 like 'note-%' ${starredFilter} ${queryFilter} AND WL011<>'Y' `;
    switch (this.noteOrder()) {
      case '1':
        this.sqlOrder = 'ORDER BY WL008 desc, WL001 desc, WL003 asc, WL002 desc';
        break;
      case '2':
        this.sqlOrder = 'ORDER BY WL001 desc, WL003 asc, WL002 desc';
        break;
      case '3':
        this.sqlOrder = 'ORDER BY WL005 desc, WL008 desc, WL003 asc, WL002 desc';
        break;
      default:
        this.sqlOrder = 'ORDER BY WL005 desc, WL003 desc';
        break;
    }
    return await this.query(this.sqlWhere, this.sqlOrder);
    //if (query.trim()) params.set('q', query.trim());
    //if (starred) params.set('starred', 'true');
    //return this.request<Mtrwl[]>(`/api/notes?${params.toString()}`);
  }
  async getWL002(WL001: string): Promise<string> {
    const sql = `SELECT MAX(WL002) AS maxSeq FROM MTRWL WHERE WL001='${WL001}'`;
    const result = await this.orm.simpleSqlPromise(this.host, sql, this.ret);
    if(!result || result.length === 0) {
      return '0001';
    }else{
      let n = result[0]?.maxSeq;
      if(!n || n === null || n === undefined || n === '') {
        return '0001';
      }
      return this.zeroAtFirst(parseInt(result[0]?.maxSeq || '0', 10) + 1, 4);
    }
  }
  async create(subject = '', content = '', category = '04'): Promise<Mtrwl> {
    this.linkMasterFields = '';
    const newNote: Mtrwl = new Mtrwl(); // await this.newRecord(new Mtrwl());
    newNote.WL001 = `note-${jkLib.nowDate()}`;
    newNote.WL002 = await this.getWL002(newNote.WL001);
    newNote.WL007 = subject;
    newNote.WL013 = content;
    newNote.WL014 = category;
    this.defaultManagerField(newNote,true);
    const bool = await this.insertData(newNote, true, this.ret);
    return newNote;
    /*return this.request<MtrwlData>('/api/notes', {
      method: 'POST',
      body: JSON.stringify({ subject, content, category }),
    });*/
  }

  async update(note: Mtrwl): Promise<Mtrwl> {
    this.defaultManagerField(note,false);
    const r = await this.updateData(this.getKeyValues(note),note);
    return note;
  }

  async setStarred(note: Mtrwl, starred: boolean): Promise<Mtrwl> {
    note.WL008 = starred ? 'Y' : 'N';
    const sql = `UPDATE MTRWL SET WL008='${starred ? 'Y' : 'N'}' WHERE WL001='${note.WL001}' AND WL002='${note.WL002}'`;
    await this.orm.simpleSqlPromise(this.host,sql,this.ret);
    return note;
  }

  async delete(note: Mtrwl): Promise<void> {
    this.ret = await this.doDelete(note,false, true);
  }


  markdown(): string {
    return this.item.WL013 || '';
  }
  editMarkdown(value: string): void {
    this.item.WL013 = value;
    //this.markEdited();
  }


}
